import React, { useState } from 'react';
import { Table } from 'reactstrap';
import { BiDownArrowAlt, BiUpArrowAlt } from "react-icons/bi";
import { ADDED_DATE_LABEL } from "../../../utils/constants";

const UsersTableHeader = ({ updateBy, role }) => {
  const [sortState, setSortState] = useState({
    field: '',
    order: ''
  });

  const handleSortBy = (field) => {
    let newOrder;
    if (sortState.field === field && sortState.order === 'asc') {
      newOrder = 'desc';
    } else if (sortState.field === field && sortState.order === 'desc') {
      newOrder = 'default';
    } else {
      newOrder = 'asc';
    }

    if (newOrder === 'default') {
      setSortState({ field: '', order: '' });
      updateBy('default', '');
    } else {
      setSortState({ field, order: newOrder });
      updateBy(field, newOrder);
    }
  };

  const renderSortArrow = (field) => {
    if (field === sortState.field) {
      return sortState.order === 'asc' ? <BiUpArrowAlt size={"22px"} /> : <BiDownArrowAlt size={"22px"} />;
    }
    return <BiDownArrowAlt size={"22px"} />;
  };

  const getMobileHeading = () => {
    if (role === 'Admin') return 'Mobile Number';
    if (role === 'User' || role === 'Member') return '';
    return 'Phone Number';
  };

  const isAdmin = !['User', 'Member'].includes(role);

  const colStyle = (width) => ({
    display: 'flex',
    justifyContent: 'center',
    cursor: 'pointer',
    width: width,
    border: '0px'
  });

  return (
    <Table bordered hover responsive className="users-table-heading-table">
      <thead>
        <tr style={{ display: 'flex', borderBottom: '2px solid #dee2e6', background: '#f78961ff' }}>
          <th style={colStyle('25%')} onClick={() => handleSortBy('name')}>
            Name {renderSortArrow('name')}
          </th>
          <th style={colStyle('16.67%')} onClick={() => handleSortBy('email')}>
            Email {renderSortArrow('email')}
          </th>
          <th style={colStyle('16.67%')} onClick={() => handleSortBy('mobileNumber')}>
            {getMobileHeading()} {isAdmin && renderSortArrow('mobileNumber')}
          </th>
          <th style={colStyle('16.66%')} onClick={() => handleSortBy('addedDate')}>
            {ADDED_DATE_LABEL} {isAdmin && renderSortArrow('addedDate')}
          </th>
          <th style={colStyle('16.67%')} onClick={() => handleSortBy('role')}>
            Role {renderSortArrow('role')}
          </th>
          <th style={{ display: 'flex', justifyContent: 'center', width: '8.33%', border: '0px' }}>
            {/* Actions */}
          </th>
        </tr>
      </thead>
    </Table>
  );
};

export default UsersTableHeader;
